import { Popover, Typography } from "@mui/material";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import AlertIcon from "../IconComponents/AlertIcon";
import { Colors } from "../Utility/Colors";
import "./style.css";
import { ticketService } from "../../service/ticketService";
import AlertNotifsList from "./AlertNotifsList";
import { NavContext } from "../../App";

export default function SpecialNotificationList(props) {
  const blue = Colors.blue750;
  const dispatch = useDispatch();
  const [notificationListOpen, setNotificationListOpen] = useState(false);
  const [specialNotifications, setSpecialNotifications] = useState([]);
  const context = useContext(NavContext)

  useEffect(() => {

    ticketService
      .getSpecialNotifications()
      .then((res) => {
        setSpecialNotifications(res.data.result.notifications);
      })
      .catch((error) => {
        // Handle any errors
        console.error("Error fetching special notifications:", error);
      });

  }, [notificationListOpen, context.newNotification]);


  const openNotificationList = (event) => {
    setNotificationListOpen(true);
  };

  const handleDrawerClose = () => {
    setNotificationListOpen(false);
  };
  return (
    <>
      <IconButton
        color={blue}
        sx={{ paddingTop: "0px" }}
        onClick={openNotificationList}
      >
        <Badge badgeContent={specialNotifications.filter(n => !n.lu).length} color="error">
          <AlertIcon />
        </Badge>
      </IconButton>

      <Popover
        open={notificationListOpen}
        onClose={(reason) => {
          handleDrawerClose();
        }}
        anchor="right"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          sx: {
            width: "370px",
            marginLeft: "-4.5%",
            marginTop: 5,
            paddingTop: 1,
          },
        }}
      >
        <div>
          <div
            style={{
              ml: 10,
              mr: 1.5,
              position: "sticky",
              top: 0,
            }}
          >
            <Typography
              sx={{
                color: "var(--Text-Title, #40464A)",
                fontFamily: "DM Sans",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: "700",
                lineHeight: "28px",
                marginLeft: "24px",
                marginTop: "24px",
                marginBottom: "24px",
              }}
            >
              Notifications
            </Typography>
          </div>
          <AlertNotifsList notifications={specialNotifications} />
        </div>
      </Popover>
    </>
  );
}
